import { VDialog, VBtn, VCard, VCardTitle, VCardText, VContent, VRow, VCol, VContainer, VCheckbox, VSelect, VCardActions, VSpacer, VForm } from 'vuetify/lib' 
import { mapGetters } from 'vuex'
import VDatePicker from '@/vuetify_custom/v-date-picker_v1'
import VTreePicker from '@/vuetify_custom/v-tree-picker'
import WageUtil from '@/views/wage/libs/util.js'
import styles from './index.module.less'
import { staff_types, list_types_hash, ALL, regular_employee_hash, button_title_hash, title_hash, payment_batch } from './fields'
function initState() {
    return {
        date: '',
        select: [],
        regular_employee_select: [],
        companies_select: [],
        staff_type: null, // 1: 正式员工 2: 实习生
        loading: false,
        payment_batch:'',
    }
}
export default {
    props: {
        title: {
            type: String,
            default: () => '测试'
        },
        list: {
            type: Array,
            default: () => []
        },
        type: {// 入口 1: 付款申请
            type: [Number, String]
        },
        buttonTitle: {
            type: [Number, String]
        }
    },
    data() {
        return {
            dis: false,
            ...initState()
        }
    },
    computed: {
        ...mapGetters({
            companies: 'async/companies',
            companies_hash: 'async/companies_hash',
          }),
          show_payment_batch() {
            const a = [1, 9].includes(this.type) && this.staff_type === 1
            const is_only_rec_award = this.select && this.select.length === 1 && this.select.includes('rec_award')
            const b = this.staff_type === 2 && !is_only_rec_award
            return a || b
          },
        list_type() {
            return list_types_hash[this.type]
        },
        regular_employee_list() {
            return regular_employee_hash[this.type]
        },
        list_companies() {
            return [
                {
                    short_name: '全选',
                    id: ALL,
                }, 
                ...this.companies
            ]
        },
    },
    watch: {
        regular_employee_select(newV, oldV) {
            if (!newV || !newV.length) {
                return
            }
            const old_v_code = oldV.map(item => item.code)
            const new_v_code = newV.map(item => item.code)
            // 全选的状态下点击 取消全选
            const cancel_all_select = old_v_code.includes(ALL) && !new_v_code.includes(ALL) && new_v_code.length === this.regular_employee_list.length - 1
            // 再选一个item实现全选
            const one_to_all = !new_v_code.includes(ALL) && !old_v_code.includes(ALL) && new_v_code.length === this.regular_employee_list.length - 1
            // 点击全选实现全选
            const click_all_to_all = !old_v_code.includes(ALL) && new_v_code.includes(ALL)
            // 取消其中一个item 置于非全选状态
            const un_all_selected = new_v_code.includes(ALL) && new_v_code.length !== this.regular_employee_list.length

            if (one_to_all || click_all_to_all) {
                this.regular_employee_select = this.regular_employee_list
                return
            }

            if (cancel_all_select) {
                this.regular_employee_select = []
                return
            }
            if (un_all_selected) {
                this.regular_employee_select = this.regular_employee_select.filter(item => item.code !== ALL)
                return
            }
        },
        companies_select(newV, oldV) {

            if (!newV || !newV.length) {
                return
            }
            const old_v_code = oldV.map(item => item.id)
            const new_v_code = newV.map(item => item.id)
            // 全选的状态下点击 取消全选
            const cancel_all_select = old_v_code.includes(ALL) && !new_v_code.includes(ALL) && new_v_code.length === this.list_companies.length - 1
            // 再选一个item实现全选
            const one_to_all = !new_v_code.includes(ALL) && !old_v_code.includes(ALL) && new_v_code.length === this.list_companies.length - 1
            // 点击全选实现全选
            const click_all_to_all = !old_v_code.includes(ALL) && new_v_code.includes(ALL)
            // 取消其中一个item 置于非全选状态
            const un_all_selected = new_v_code.includes(ALL) && new_v_code.length !== this.list_companies.length

            if (one_to_all || click_all_to_all) {
                this.companies_select = this.list_companies
                return
            }
            if (cancel_all_select) {
                this.companies_select = []
                return
            }
            if (un_all_selected) {
                this.companies_select = this.companies_select.filter(item => item.id !== ALL)
                return
            }
        }
    },
    methods: {
        
        show() {
            const data = initState()
            this.dis = true
            Object.keys(data).forEach(key => {
                this[key] = data[key]
            })
            console.log()
            switch (Number(this.type)) {
                case 8:
                    this.staff_type = 1
                    break;
                default:
                    break;
            }
        },
        submitFormalityCommon() {
           this.loading = true
           const params = {
                month:this.date, 
                payment_type: this.type, 
           }
           if (this.staff_type === 1) {
                params.codes = this.regular_employee_select.map(item => item.code).filter(item => item !== ALL)
                params.company_ids = this.companies_select.map(item => item.id).filter(item => item !== ALL)
           }
           if (this.staff_type === 2) {
                params.bills = this.select
           }
           if (this.show_payment_batch) {
                params.payment_batch = this.payment_batch
           }
           this.loading = true
            WageUtil.genBill(params, this.staff_type === 1).then(() => {
                if (this.staff_type === 1) {
                    this.$Modal.info({title: '提示', content: '单据生成需求已提交，请注意查看企业微信消息'});
                } 
                if (this.staff_type === 2 && this.type === 1) {
                    this.$Message.success({content: '你的申请已提交，请2分钟后查看', duration: 3});
                }
                if (this.staff_type === 2 && this.type === 9) {
                    this.$Message.success({content: '你的申请已提交，请查看企业微信结果通知', duration: 3});
                }
                this.close()
              }).finally(() => {
                this.loading = false
            });
        },
        close() {
            const data = initState()
            Object.keys(data).forEach(key => {
                this[key] = data[key]
            })
            this.dis = false
            this.$refs.form.resetValidation()
        },
        validate() {
            return this.$refs.form.validate()
        },
        ok() {
            if (this.validate()) {
                this.submitFormalityCommon()
            }
        },

    },
    render() {
       return <div class={styles.contain}>
           <VBtn on={{
               click: this.show
           }}>{button_title_hash[this.type]}</VBtn>
           <VDialog 
                v-model={this.dis}
                persistent
                max-width="600px"
            >
                <VCard> 
                    <VCardTitle>
                        <span>{title_hash[this.type]}</span>
                    </VCardTitle>
                    <VCardText>
                        <VContent>
                            <VForm 
                                ref="form" 
                            >
                                <VRow>
                                    <VCol cols="6">
                                        <VDatePicker
                                            required
                                            v-model={ this.date }
                                            type="month"
                                            placeholder="选择月份"
                                            label="选择月份"
                                            rules={[val => !!val || '必选']}
                                            />
                                    </VCol>
                                    <VCol cols="6"/>
                                    <VCol cols="6">
                                        <VSelect
                                            required
                                            disabled={this.type === 8}
                                            v-model={this.staff_type}
                                            prepend-icon="mdi-account"
                                            item-text="label"
                                            item-value="value"
                                            label="类型"
                                            items={staff_types}
                                            rules={[val => !!val || '人员类型必选', 
                                            /*() => {
                                                if (this.staff_type === 1) {
                                                    return true
                                                }
                                                return (this.select && !!this.select.length) || '非正式员工相关至少选择一项'
                                            }*/
                                        ]}
                                        />
                                    </VCol>
                                    <VCol cols="6"/>
                                    {this.staff_type === 1 && <VCol cols="12">
                                        <VTreePicker 
                                            prependIcon="mdi-badge-account-horizontal"
                                            required
                                            label="公司"
                                            v-model={this.companies_select}
                                            item-key='id'
                                            item-text='short_name'
                                            items = {this.list_companies}
                                            display={(data) => {
                                                if (!data) {
                                                    return ''
                                                }
                                                return data.filter(item => item.id !== ALL
                                                    ).map(item => item.short_name).join('；')
                                            }}
                                          //   rules={[val => (val && !!val.length) || '请选择至少一项']}
                                        />
                                    </VCol>}
                                    {this.staff_type === 1 && <VCol cols="12">
                                        <VTreePicker 
                                            required
                                            label="费用类型"
                                            v-model={this.regular_employee_select}
                                            item-key='code'
                                            item-text='name'
                                            items = {this.regular_employee_list}
                                            display={(data) => {
                                                if (!data) {
                                                    return ''
                                                }
                                                return data.filter(item => item.code !== ALL
                                                    ).map(item => item.name).join('；')
                                            }}
                                          //   rules={[val => (val && !!val.length) || '请选择至少一项']}
                                        />
                                    </VCol>}
                                    {this.staff_type === 2 && <VCol cols="12">
                                        <VContainer>
                                            {this.list_type && this.list_type.map(item => <VCheckbox
                                                class={styles.item}
                                                v-model={this.select}
                                                key={item.value}
                                                label={item.label}
                                                value={item.value}
                                               rules={[val => (val && !!val.length) || '请选择至少一项']}
                                                on = {{
                                                    change:() => {
                                                        this.validate()
                                                    }
                                                }}
                                            />)}
                                        </VContainer>
                                    </VCol>}
                                    {this.show_payment_batch && <VCol cols="6">
                                        <VSelect
                                                required
                                                v-model={this.payment_batch}
                                                item-text="label"
                                                item-value="value"
                                                label="付款批次"
                                              //  multiple
                                                items={payment_batch}
                                                rules={[val => val && !!val.length || '必选', 
                                                /*() => {
                                                    if (this.staff_type === 1) {
                                                        return true
                                                    }
                                                    return (this.select && !!this.select.length) || '非正式员工相关至少选择一项'
                                                }*/
                                            ]}
                                            />
                                    </VCol>}
                                </VRow>
                            </VForm>
                        </VContent>
                    </VCardText>
                    <VCardActions>
                        <VSpacer/>
                        <VBtn
                            text
                            on ={{
                                click: () => this.close()
                            }}
                        >
                            取消
                        </VBtn>
                        <VBtn
                            color="primary"
                            text
                            on ={{
                                click: () => this.ok() 
                            }}
                            loading={this.loading}
                        >
                            确定
                        </VBtn>
                    </VCardActions>
                </VCard>
                
            </VDialog>
       </div> 
    }
}